import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getImage } from "@root/_utils";
import { LoadingSpinner } from "@proxy/_components";
import VideoPlayer from "./VideoPlayer";

export default function VideoMessage({ thumbnailUrl, videos, translations, loading, error }) {


  const isPlayable = useCallback((videos) => {

    let obj = document.createElement('video');

    const canPlay = Array.isArray(videos) ? videos.map(video => (
      obj.canPlayType(video.mimeType)
    )) : [];

    if (canPlay.includes("probably")) {
      return "playable";
    }

    if (canPlay.includes("maybe")) {
      return "maybe";
    }

    return "download";

  }, []);

  const playable = useMemo(() => isPlayable(videos), [videos]);

  // useEffect(() => {
  //   canPlayVideos();
  // }, [videos]);

  const DownloadLinkMarkup = () => {
    return (
      <>
        {
          (playable == "maybe" || playable == "download") && (Array.isArray(videos) && videos.length >= 1 && videos[0].file != undefined) ?
          <a href={videos[0].file} download rel="noreferrer" target="_blank" >{ playable == "maybe" ? translations.landing.download_video : translations.landing.download_switch_browser }</a> :
          <></>
        }
      </>
    );
  };

  const VideoPlayerMarkup = () => {
    return (
      <div className="gc__message_wrapper">
        <div className="gc__video_message_container">
          <div style={{display: 'flex', flexDirection: 'column'}}>
            {
              error === true ?
              <div>
                { translations.errors.video_load_error }
              </div> :
              <>
                {
                  playable == "playable" || playable == "maybe" ?
                  <VideoPlayer
                    thumbnail={thumbnailUrl}
                    videos={videos}
                  /> :
                  <></>
                }
                <DownloadLinkMarkup />
              </>
            }
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {
        loading == true ?
        <LoadingSpinner /> :
        <VideoPlayerMarkup />
      }
    </>
  );

};
